import { isObject } from "@perxis-auto/shared/lib/lib/is/isObject";
function replacePattern(template, values = {}) {
  return template.replace(/:([a-zA-Z0-9_]+)/g, (match, key) => values[key] ?? match);
}
function replaceNavigateToPattern(to, params = {}) {
  return isObject(to) ? Object.fromEntries(Object.entries(to).map(([key, val]) => [key, replacePattern(val, params)])) : replacePattern(to, params);
}
export {
  replaceNavigateToPattern
};
